export default __webpack_public_path__ + "static/media/corporate_yoga.75ad3b23.png";